// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import VueScroller from 'vue-scroller'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 3,
  loading: require('./assets/lazy_load.gif'),
  attempt: 1
})

Vue.use(Vuex)
Vue.use(VueScroller)


Vue.config.productionTip = false

let bus = new Vue()
Vue.prototype.bus = bus

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js